import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../../../../utils/styles';
import Icons from '../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../components/Common/UI/Button';
import FormContent from './FormContent';
import { LogoFromSettings } from '../../../Common/Logo';
// import SecureLogin from './SecureLogin';

export type StepDirectionType = 'next' | 'prev';

function SignInGuidance() {
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);

  const handleStep = (direction?: StepDirectionType) => {
    setStep(prevState => prevState + (direction === 'prev' ? -1 : 1));
  };

  return (
    <div className={cn(['max-w-5xl mx-auto flex flex-col gap-4 items-start'])}>
      <header className="h-20 flex items-center px-4">
        <Button variant="ghost" size="auto" className="font-bold" onClick={() => navigate('/')}>
          <Icons.ArrowLeft className="rotate-180 child:opacity-100 text-lg" />
          Back
        </Button>
      </header>

      <main className={cn(['w-full grid md:grid-cols-2', 'min-h-[615px] rounded-lg px-4'])}>
        <div className="md:flex hidden m-auto justify-center" style={{ transform: 'translate(0, -34px)' }}>
          <LogoFromSettings size="lg" />
        </div>

        <div
          className={cn(['rounded-r-lg', 'py-8 px-[36px] md:py-12 md:px-[70px]', 'flex justify-center items-center'])}
        >
          {step === 1 ? (
            <FormContent
              handleStep={() => navigate('/guidance/financial-institution')}
              // handleStep={handleStep}
            />
          ) : null}

          {/** Step 2 disabled for a moment. */}
          {/* {step === 2 ? (
            <SecureLogin handleStep={handleStep} />
          ) : null} */}
        </div>
      </main>
    </div>
  );
}

export default SignInGuidance;
